import * as actionTypes from '../../actions/actionTypes';

const httpActionTypes = actionTypes.httpActionTypes;

/**
 * Request sub-reducer: update the nested request object
 * @param {object} state - current state
 * @param {object} action
 * @return {object} next state
 */
function request(state = {}, action) {
	switch(action.type) {
		case httpActionTypes.FACEBOOK_REQUEST_MADE:
		case httpActionTypes.IAM_REQUEST_MADE:
			return {
				[action.request]: {
					...state,
					isInflight: true
				}
			};
		case httpActionTypes.FACEBOOK_REQUEST_SUCCESS:
		case httpActionTypes.IAM_REQUEST_SUCCESS:
			return {
				[action.request]: {
					...state,
					isInflight: false,
					isError: false
				}
			};
		case httpActionTypes.FACEBOOK_REQUEST_ERROR:
		case httpActionTypes.IAM_REQUEST_ERROR:
			return {
				[action.request]: {
					...state,
					isInflight: false,
					isError: action.error
				}
			};

	}
};

/**
 * HTTP request reducer: update HTTP request branch
 * @param {object} state - current state
 * @param {object} action
 * @return {object} next state
 */
export function HTTP_request(state = {}, action) {
	switch (action.type) {
		case httpActionTypes.FACEBOOK_REQUEST_MADE:
		case httpActionTypes.IAM_REQUEST_MADE:
		case httpActionTypes.FACEBOOK_REQUEST_SUCCESS:
		case httpActionTypes.IAM_REQUEST_SUCCESS:
		case httpActionTypes.FACEBOOK_REQUEST_ERROR:
		case httpActionTypes.IAM_REQUEST_ERROR:
			return {
				...state,
				...request(state[action.request], action),
			};
		default:
			return state;
	}
}

/**
 * UI selectors
 */

/**
 * getRecoverableErrorType
 * @desc Get a recoverable error type key for intl lookup, based on the error key and request
 * @param {object} state - current state
 * @param {string} request - request
 * @param {string} networkStatus - navigator.onLine value
 * @return {string} error message key
 */
export const getRecoverableErrorType = (state, request, networkStatus) => {
	if (!state) {
		return false;
	}
	switch (request) {
		case 'facebook_connect':
			const _isOffline = isOffline(state, networkStatus);
			const newState = (state === 'fb_user_denied_email') ? 'fb_user_denied_email' : 'facebook_connect';
			return _isOffline || newState;
		case 'iam_jg_login':
			return isOffline(state, networkStatus) || state;
		case 'iam_facebook_login':
			return isOffline(state, networkStatus) || state;
		case 'iam_email_check':
			return isOffline(state, networkStatus) || state;
		case 'iam_register':
			return isOffline(state, networkStatus) || state;
		default:
			return true;
	}
};

export const isOffline = (state, networkStatus) => {
	return state === 'iam_request_timeout' && networkStatus === 'offline' ? 'offline' : false;
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/reducers/reducers/httpReducers.js